import React, { useEffect, useState } from "react";
import classNames from 'classnames';

import ElementModal from "./ElementModal";
import Checkbox from "../Checkbox";
import Row from "../Layout/Row";

import { projects } from "../../constants";
import style from './_modal.module.scss';


export default function DeviceTypeModal({isOpen, onClose, onSubmit, initialValue}) {
	let className = classNames(style.modal);

	let [typeId, setTypeId] = useState(initialValue);
	useEffect(() => setTypeId(initialValue), [initialValue])

	function submit() {
		onSubmit(typeId);
	}

	return (
		<ElementModal isOpen={isOpen} onClose={onClose} className={className} submit={submit}>
			<div className={style.section}>
				<div className={style.title}>TIPOLOGIA</div>
				{
					projects.types.map(({name, id}) =>
						<Row key={id}>
							<Checkbox
								checked={typeId === id}
								onCheck={() => setTypeId(id)}
							/>
							{name}
						</Row>
					)
				}
			</div>
		</ElementModal>
	)

}
